import React, { useState, useEffect } from "react";
import tw, { styled, css } from "twin.macro";
import { Link } from "gatsby";
import _ from "lodash";

const Wrapper = styled.div`
  ${tw`xl:pt-6`}
`;

const SubMenu = styled.div`
  ${tw`
      w-full xl:max-w-5xl
      text-gray-400 xl:text-white xl:text-sm
      xl:bg-gray-800 
      xl:border-2 xl:border-gray-400
  `}

  @media (min-width: 1280px) {
    min-width: 20em;
  }
`;

const Columns = styled.div`
  ${tw`xl:flex xl:flex-wrap`}
`;

const ColHeader = styled.div`
  ${tw`
    hidden xl:inline-block
    xl:pb-4 xl:pt-0
    font-semibold uppercase
    cursor-pointer xl:cursor-default
    `}

  @media (max-width: 1279px) {
    ${tw`py-4 pl-8 pr-5`}
  }
`;

const Column = styled.div`
  ${tw`
        xl:p-8
        border-gray-400 w-full
    `}
`;

const ColBodyList = styled.ul`
  ${tw`
        list-none
        xl:grid xl:grid-cols-1 gap-4
    `}

  @media (max-width: 1279px) {
    ${tw`w-full overflow-hidden max-h-full`}
  }
`;

const ColBodyListItem = styled.li`
  ${tw`flex items-center`}

  ${({ onlyMobile }) => onlyMobile && tw`xl:hidden`}

  @media (max-width: 1279px) {
    ${tw`
        hover:text-white
        border-b-2 border-dotted border-gray-400
        transition-[color] duration-200
    `}

    &:last-child {
      ${tw`border-none`}
    }
  }
`;

const ColBodyLink = styled(Link)`
  ${tw`
        w-full
        flex items-center 
        hover:cursor-pointer
    `}

  > img {
    ${tw`h-6 w-6 mr-1.5`}
  }

  > button {
    ${tw`inline-block py-3.5 px-8 w-full text-left`}
  }

  @media (min-width: 1280px) {
    ${tw`py-0 px-0`}
    > button {
      ${tw`relative inline px-0 py-0`}

      &::after {
        ${tw`
        absolute bottom-0 left-0
        w-full h-0.5
        origin-bottom-left transition-transform ease-out duration-200
      `}
        background-color: ${(props) => props.color};
        content: "";
        transform: scaleX(0);
      }

      :hover::after {
        transform: scaleX(1);
      }
    }
  }
`;

const ColBodyAnchor = styled.a`
  ${tw`
        w-full
        flex items-center 
        hover:cursor-pointer
    `}

  > img {
    ${tw`h-6 w-6 mr-1.5`}
  }

  > button {
    ${tw`inline-block py-3.5 px-8 w-full text-left`}
  }

  @media (min-width: 1280px) {
    ${tw`py-0 px-0`}
    > button {
      ${tw`relative inline px-0 py-0`}

      &::after {
        ${tw`
        absolute bottom-0 left-0
        w-full h-0.5
        origin-bottom-left transition-transform ease-out duration-200
      `}
        background-color: ${(props) => props.color};
        content: "";
        transform: scaleX(0);
      }

      :hover::after {
        transform: scaleX(1);
      }
    }
  }
`;

const NavSubMenu = ({ hoveredLink, onClick, color }) => {
  const [mql, setMql] = useState();
  const [hoveredNavItem, setHoveredNavItem] = useState(hoveredLink);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setMql(window.matchMedia("(max-width: 1280px)"));
    }
  }, []);

  const links = _.get(hoveredNavItem, "links", []);

  return (
    <>
      {!_.isNil(hoveredNavItem) && !_.isEmpty(links) && (
        <Wrapper>
          <SubMenu isSingleCol={true}>
            <Columns>
              <Column>
                {/* <ColHeader>Categories</ColHeader> */}
                <ColBodyList open={true}>
                  {(links || []).map(({ label, to, external }, linkIdx) => {
                    return (
                      <ColBodyListItem key={linkIdx}>
                        {external ? (
                          <ColBodyAnchor
                            href={to}
                            target="_blank"
                            color={color}
                          >
                            <button onClick={onClick}>{label}</button>
                          </ColBodyAnchor>
                        ) : (
                          <ColBodyLink to={to} color={color}>
                            <button onClick={onClick}>{label}</button>
                          </ColBodyLink>
                        )}
                      </ColBodyListItem>
                    );
                  })}
                </ColBodyList>
              </Column>
            </Columns>
          </SubMenu>
        </Wrapper>
      )}
    </>
  );
};

export default NavSubMenu;
